import http from '../lib/http';

// Get user orders
export const getUserOrders = async () => {
    try {
        const response = await http.get('/api/customer/orders');
        return response.data;
    } catch (error) {
        console.error('Error fetching orders:', error);
        throw error;
    }
};

// Get order by ID
export const getOrderById = async (orderId) => {
    try {
        const response = await http.get(`/api/customer/orders/${orderId}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching order:', error);
        throw error;
    }
};

// Extract all products from orders for review purposes
export const getOrderedProductsForReview = async () => {
    try {
        const response = await getUserOrders();

        // Handle different response structures
        let orders = [];
        if (Array.isArray(response?.data)) {
            orders = response.data;
        } else if (Array.isArray(response)) {
            orders = response;
        }

        // Extract unique products from all orders
        const productsMap = new Map();

        orders.forEach((order) => {
            // Try multiple possible item keys
            let items = order.items || order.order_items || order.orderItems || order.line_items || [];

            // If items is empty, try to extract from nested data
            if (!items || items.length === 0) {
                if (order.data?.items) items = order.data.items;
                if (order.orderItems) items = order.orderItems;
            }

            if (!Array.isArray(items) || items.length === 0) {
                return;
            }

            items.forEach((item) => {
                // Handle different item structures
                const product = item.product || item;
                const productId = product?.id || product?.product_id || item.product_id;

                if (productId && !productsMap.has(productId)) {
                    productsMap.set(productId, {
                        id: productId,
                        name: product.name || product.product_name || item.product_name || 'Unknown Product',
                        brand: product.brand || item.brand || '',
                        image: product.product_images?.[0] || product.image_url || product.image || item.image || '',
                        orderId: order.id,
                        orderNo: order.order_no || order.order_number || order.id,
                        orderDate: order.created_at,
                        color: item.color || product.color || '',
                        size: item.size || product.size || ''
                    });
                }
            });
        });

        return Array.from(productsMap.values());
    } catch (error) {
        console.error('Error fetching ordered products:', error);
        throw error;
    }

    
};

// Get products only from delivered orders
export const getDeliveredOrderedProductsForReview = async () => {
  try {
    const response = await getUserOrders();

    let orders = [];
    if (Array.isArray(response?.data)) {
      orders = response.data;
    } else if (Array.isArray(response)) {
      orders = response;
    }

    // Filter delivered orders
    const deliveredOrders = orders.filter(
      (order) => String(order.status).toLowerCase() === "delivered"
    );

    const productsMap = new Map();

    deliveredOrders.forEach((order) => {
      const items = Array.isArray(order.items) ? order.items : [];

      items.forEach((item) => {
        const product = item.product || {};
        const productId = item.product_id || product.id;

        if (productId && !productsMap.has(productId)) {
          productsMap.set(productId, {
            id: productId,
            name: product.name || "Unknown Product",
            brand: product.brand || "",
            image: product.product_images?.[0] || "",
            orderId: order.id,
            orderNo: order.order_no || order.id,
            orderDate: order.created_at,
            color: item.color || "",
            size: item.size || "",
          });
        }
      });
    });

    return Array.from(productsMap.values());
  } catch (error) {
    console.error("Error fetching delivered ordered products:", error);
    throw error;
  }
};
